export default function SkeletonProductGrid() {
  return (
    <div className="flex w-full flex-col gap-4">
      {Array.from({ length: 6 }).map((_, i) => (
        <div
          key={i}
          className="bg-white-20 h-20 w-full animate-pulse rounded-md"
        />
      ))}
    </div>
  );
}
